<template>
  <div class="home-container">
    <TechBackground />
    
    <div class="home-content">
      <div class="header">
        <h1 class="title">食品安全监控中心</h1>
        <p class="subtitle">Food Safety Monitoring Center</p>
      </div>
      
      <div class="nav-grid">
        <router-link :to="getRoutePath('/daily-record')" class="nav-card daily-record">
          <div class="card-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line>
              <line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg>
          </div>
          <div class="card-content">
            <h3>每日记录</h3>
            <p>Daily Record</p>
          </div>
          <div class="card-arrow">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </div>
        </router-link>
        
        <div class="nav-card coming-soon">
          <div class="card-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
              <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
              <line x1="12" y1="22.08" x2="12" y2="12"></line>
            </svg>
          </div>
          <div class="card-content">
            <h3>统计分析</h3>
            <p>Statistics</p>
          </div>
          <div class="card-badge">即将上线</div>
        </div>
        
        <div class="nav-card coming-soon">
          <div class="card-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
              <path d="M3 9h18"></path>
              <path d="M9 21V9"></path>
            </svg>
          </div>
          <div class="card-content">
            <h3>库存详情</h3>
            <p>Inventory Detail</p>
          </div>
          <div class="card-badge">即将上线</div>
        </div>

        <router-link :to="getRoutePath('/menu')" class="nav-card daily-record">
          <div class="card-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M18 8h1a4 4 0 0 1 0 8h-1"></path>
              <path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"></path>
              <line x1="6" y1="1" x2="6" y2="4"></line>
              <line x1="10" y1="1" x2="10" y2="4"></line>
              <line x1="14" y1="1" x2="14" y2="4"></line>
            </svg>
          </div>
          <div class="card-content">
            <h3>本周菜单</h3>
            <p>Weekly Menu</p>
          </div>
          <div class="card-arrow">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </div>
        </router-link>
      </div>
      
      <div class="footer">
        <p>© 2024 食品安全监控中心 | Food Safety Monitoring Center</p>
      </div>
    </div>
  </div>
</template>

<script>
import TechBackground from '../components/TechBackground.vue'

export default {
  name: 'Home',
  components: {
    TechBackground
  },
  mounted() {
  },
  methods: {
    getRoutePath(path) {
      const params = new URLSearchParams(window.location.search)
      return {
        path,
        query: {
          company_id: params.get('company_id'),
          cost_center_id: params.get('cost_center_id'),
          screen_id: params.get('screen_id')
        }
      }
    }
  }
}
</script>

<style scoped>
.home-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.home-content {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
}

.header {
  text-align: center;
  margin-bottom: 60px;
  animation: slideDown 0.8s ease-out;
}

.title {
  font-size: 56px;
  font-weight: 700;
  color: #e2e8f0;
  text-shadow: 0 0 30px rgba(99, 179, 237, 0.5);
  margin: 0 0 16px 0;
  letter-spacing: 8px;
}

.subtitle {
  font-size: 18px;
  color: #63b3ed;
  margin: 0;
  letter-spacing: 2px;
}

.nav-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  max-width: 1000px;
  width: 100%;
  animation: slideUp 0.8s ease-out 0.2s both;
}

.nav-card {
  position: relative;
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 32px;
  background: rgba(26, 54, 93, 0.6);
  border: 1px solid rgba(99, 179, 237, 0.3);
  border-radius: 16px;
  text-decoration: none;
  transition: all 0.3s ease;
  cursor: pointer;
}

.nav-card:hover {
  background: rgba(49, 130, 206, 0.3);
  border-color: rgba(99, 179, 237, 0.6);
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(49, 130, 206, 0.3);
}

.nav-card.daily-record {
  animation: fadeIn 0.6s ease-out 0.3s both;
}

.nav-card.coming-soon {
  opacity: 0.7;
  cursor: not-allowed;
}

.nav-card.coming-soon:hover {
  transform: none;
  box-shadow: none;
}

.card-icon {
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(99, 179, 237, 0.2);
  border-radius: 12px;
  flex-shrink: 0;
}

.card-icon svg {
  width: 32px;
  height: 32px;
  color: #63b3ed;
}

.card-content {
  flex: 1;
}

.card-content h3 {
  font-size: 20px;
  font-weight: 600;
  color: #e2e8f0;
  margin: 0 0 4px 0;
}

.card-content p {
  font-size: 14px;
  color: #a0aec0;
  margin: 0;
}

.card-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: rgba(99, 179, 237, 0.2);
  border-radius: 50%;
  flex-shrink: 0;
}

.card-arrow svg {
  width: 20px;
  height: 20px;
  color: #63b3ed;
}

.card-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  padding: 4px 12px;
  background: rgba(250, 204, 21, 0.2);
  border: 1px solid rgba(250, 204, 21, 0.4);
  border-radius: 4px;
  font-size: 12px;
  color: #facc15;
}

.footer {
  position: absolute;
  bottom: 40px;
  text-align: center;
  animation: fadeIn 0.8s ease-out 0.4s both;
}

.footer p {
  font-size: 14px;
  color: #718096;
  margin: 0;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media (max-width: 1200px) {
  .title {
    font-size: 42px;
    letter-spacing: 4px;
  }
  
  .nav-grid {
    gap: 16px;
  }
  
  .nav-card {
    padding: 24px;
  }
}

@media (max-width: 768px) {
  .nav-grid {
    grid-template-columns: 1fr;
  }
  
  .title {
    font-size: 32px;
  }
}
</style>